module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!C:\\Work\\repo\\metabase\\metabase_wh\\node_modules\\babel-loader\\lib\\index.js??ref--0-0!C:\\Work\\repo\\metabase\\metabase_wh\\node_modules\\eslint-loader\\index.js!C:\\Work\\repo\\metabase\\metabase_wh\\frontend\\src\\metabase\\lib\\ga-metadata.js"));
    });
  });
}


//////////////////
// WEBPACK FOOTER
// C:/Work/repo/metabase/metabase_wh/node_modules/promise-loader?global!./lib/ga-metadata.js
// module id = 371
// module chunks = 3 4 5